export default __webpack_public_path__ + "static/shiny-1db270d943d45d0e592f46fdd95ace3c.png";